<template>
  <div
    class="col-sm-6 col-lg-4 reciepe-list-element"
    style="cursor: pointer"
    @click="$emit('goToReciepe', $vnode.key)"
  >
    <h3>
      {{ name }}
    </h3>
    <p>{{ description }}</p>
  </div>
</template>
<script>
export default {
  name: "reciepe",
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      expand: false
    };
  }
};
</script>
<style>
.reciepe-list-element {
  align-self: center;
  border-radius: 10px;
}
.reciepe-list-element:hover {
  background-color: rgb(240, 240, 240);
}
</style>
